import { render } from "./InsertStudentLevel.vue?vue&type=template&id=57f9e8ed&scoped=true"
import script from "./InsertStudentLevel.vue?vue&type=script&lang=js"
export * from "./InsertStudentLevel.vue?vue&type=script&lang=js"

import "./InsertStudentLevel.vue?vue&type=style&index=0&id=57f9e8ed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57f9e8ed"]])

export default __exports__